import React, { useEffect, useState } from "react";

//route
import { useNavigate } from "react-router-dom";
import campagneReseauxSociauxService from "./../../../../services/MarketingService/CampagneReseauxSociauxService";
import Datetime from "react-datetime";
import toastr from 'toastr';
import 'toastr/build/toastr.min.css';

function AddCampagneReseauxSociaux() {

  const [nom, setNom] = useState("");

  const [objectif, setObjectif] = useState("");
  const [objectifsData, setObjectifsData] = useState([]);

  const [type, setType] = useState("");
  const [typesData, setTypesData] = useState([]);

  const [canalDiffusion, setCanalDiffusion] = useState("");
  const [canalDiffusionsData, setCanalDiffusionsData] = useState([]);

  const [contenu, setContenu] = useState("");
  const [cible, setCible] = useState("");

  const [publicationDate, setpublicationDate] = useState(null);

  const [PiecesJoints, setPiecesJoints] = useState("");
  const [piecesJointesdata, setPiecesJointesdata] = useState([]);

  const [erreur, setErreur] = useState(null);
  const [success, setSuccess] = useState(null);
  const navigate = useNavigate(); // route
  //date
  const handleDateChange = (date) => {
    setpublicationDate(date);
  };
  //pieces joints
  const handlePieceJointeChange = (event) => {
    setPiecesJointesdata([...piecesJointesdata, event.target.files[0]]);
  };
  const handleDeletePieceJointe = () => {
    // Create a copy of the piecesJointesdata array
    const newPiecesJointesData = [...piecesJointesdata];

    // Remove the last item from the array
    newPiecesJointesData.pop();

    // Update the state with the new array
    setPiecesJointesdata(newPiecesJointesData);

    // Reset the file input field
    //document.getElementById("pieces-jointes").value = null;
  };

  useEffect(() => {
    AfficherListObjectifs();
    AfficherListTypes();
    AfficherListCanalDiffusion();
  }, []);

  useEffect(() => {
    if (success) {
      const timeoutId = setTimeout(() => {
        setSuccess(null);
      }, 2000); // 30 secondes en millisecondes
      return () => clearTimeout(timeoutId);
    }
    if (erreur) {
      const timeoutId = setTimeout(() => {
        setErreur(null);
      }, 2000); // 30 secondes en millisecondes
      return () => clearTimeout(timeoutId);
    }
  }, [success, erreur]);

  const AfficherListObjectifs = async () => {
    try {
      campagneReseauxSociauxService.AfficherListObjectifs().then((response) => {
        setObjectifsData(response.data.success);

      }).catch((error) => {
        console.log("error", error);
      })
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };
  //methode pour afficher status
  // const AfficherListStatus = async () => {
  //   try {
  //     campagneReseauxSociauxService.AfficherListStatus().then((response) => {
  //       setStatutsData(response.data.success);
  //     }).catch((error) => {
  //       console.log("error", error);

  //     })
  //   } catch (error) {
  //     console.log(error);
  //     setErreur(error.message);
  //   }
  // };
  //methode pour afficher types
  const AfficherListTypes = async () => {
    try {
      campagneReseauxSociauxService.AfficherListTypes().then((response) => {
        setTypesData(response.data.success);
      }).catch((error) => {
        console.log("error", error);

      })
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  //methode pour afficher Canal de Diffusions
  const AfficherListCanalDiffusion = () => {
    try {
      campagneReseauxSociauxService.AfficherListCanalDiffusion().then((response) => {
        setCanalDiffusionsData(response.data.success);

      }).catch((error) => {
        console.log("error", error);

      })
    } catch (error) {
      console.log(error);
      setErreur(error.message);
    }
  };

  //methode d'ajout
  const ajouterPublication = () => {

    if (!nom || !objectif) {
      setErreur("Veuillez renseigner tous les champs.");
      // return;
    }

    const nouveauPublication = {
      nom: nom,
      objectif: objectif,
      type: type,
      canalDiffusion: canalDiffusion,
      contenu: contenu,
      publicationDate: publicationDate,
    };

    const formData = new FormData();

    if (piecesJointesdata && piecesJointesdata.length > 0) {
      for (let i = 0; i < piecesJointesdata.length; i++) {
        formData.append("piecesJointes", piecesJointesdata[i]);
      }
    }

    // Appeler la méthode "ajouterPublication()" de "campagneReseauxSociauxService" en passant formData comme argument
    try {
      // console.log
      campagneReseauxSociauxService.ajouterCampagneReseauxSociaux(
        nouveauPublication,
        piecesJointesdata
      ).then((response) => {
        console.log(response.data); // Afficher la réponse (optionnel)

      })

      toastr.success("Ajout validée avec success !! ")

      // setSuccess("Ajout validée avec success !! ");
      setTimeout(() => {
        navigate(`/Campagne/PageCampagneR`);
      }, 2000);
      // Réinitialiser les champs vides
      // setNom("");
      // setObjectif("");
      // setType("");
      // setCanalDiffusion("");
      // setContenu("");
      // //setCible("");
      // setpublicationDate(null); // Réinitialiser la date de publication à null
      // setPiecesJointesdata([]);
      // setSuccess("Ajout validé avec succès !");
    } catch (error) {
      console.log(error); // Afficher l'erreur (optionnel)
      toastr.error("Erreur lors de l'insertion." + error)

    }
  };
  return (
    <div className="content-wrapper" style={{ marginTop: "0" }} s>
      <div className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1 className="m-0">Campagne Reseaux Sociaux</h1>
            </div>
            <div className="col-sm-6">
              {/* <ol className="breadcrumb float-sm-right">
                <li className="breadcrumb-item">
                  <a href="/">Marketing</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/Campagne">Campagne</a>
                </li>
                <li className="breadcrumb-item">
                  <a href="/PageCampagneR">Reseaux Sociaux</a>
                </li>
                <li className="breadcrumb-item active">Creation</li>
              </ol> */}
            </div>
          </div>
        </div>
      </div>
      {/* /.content-header */}

      {/* content */}
      <section className="content">
        {/* container-fluid */}
        <div className="container-fluid">
          <div className="card card-dark">
            <div className="card-header">
              <h3 className="card-title">
                Ajouter Campagne sur les Reseaux Sociaux
              </h3>
            </div>
            <form >
              <div className="card-body">
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Nom</label>
                  <input
                    type="text"
                    className="form-control"
                    id="exampleInputEmail1"
                    placeholder="Nom"
                    value={nom}
                    onChange={(event) => setNom(event.target.value)}
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Objectif</label>
                  <select
                    className="custom-select"
                    id="type"
                    value={objectif}
                    onChange={(e) => setObjectif(e.target.value)}
                  >
                    <option value="">--</option>
                    {objectifsData.map((objectif) => (
                      <option key={objectif} value={objectif}>
                        {objectif}
                      </option>
                    ))}
                  </select>
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col">
                      <label htmlFor="exampleInputEmail1">
                        Canal de diffusion
                      </label>
                      <select
                        className="custom-select"
                        id="type"
                        value={canalDiffusion}
                        onChange={(e) => setCanalDiffusion(e.target.value)}
                      >
                        <option value="">--</option>
                        {canalDiffusionsData.map((canalDiffusion) => (
                          <option key={canalDiffusion} value={canalDiffusion}>
                            {canalDiffusion}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="col">
                      <label htmlFor="exampleInputEmail1">Type</label>
                      <select
                        className="custom-select"
                        id="type"
                        value={type}
                        onChange={(e) => setType(e.target.value)}
                      >
                        <option value="">--</option>
                        {typesData.map((type) => (
                          <option key={type} value={type}>
                            {type}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="exampleInputEmail1">Contenu</label>
                  <textarea
                    className="form-control"
                    rows="3"
                    placeholder="Contenu ..."
                    value={contenu}
                    onChange={(event) => setContenu(event.target.value)}
                  />
                </div>

                <div className="form-group">
                  <div className="row">
                    <div className="col">
                      <div className="form-group">
                        <label htmlFor="exampleInputEmail1">
                          Date and Time:
                        </label>
                        <Datetime
                          onChange={handleDateChange}
                          value={publicationDate}
                          inputProps={{ placeholder: "Select date and time" }}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="pieces-jointes">Pieces jointes</label>
                  <div className="input-group">
                    <div className="custom-file">
                      <input
                        type="file"
                        className="custom-file-input"
                        id="pieces-jointes"
                        name="pieces-jointes"
                        value={PiecesJoints}
                        onChange={handlePieceJointeChange}
                      />
                      <label
                        className="custom-file-label"
                        htmlFor="pieces-jointes"
                      >
                        {piecesJointesdata.length === 0
                          ? "Choose file"
                          : piecesJointesdata
                            .map((fichier) => fichier.name)
                            .join(", ")}
                      </label>
                    </div>
                    {piecesJointesdata.length > 0 && (
                      <div className="input-group-append">
                        <button
                          className="btn btn-outline-secondary"
                          type="button"
                          onClick={handleDeletePieceJointe}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </div>
                    )}
                  </div>
                  {/* affichage des images  */}
                  <div className="row mt-3">
                    {piecesJointesdata.map((fichier, index) => (
                      <div key={index} className="col-sm-3 text-center mb-3">
                        <img
                          src={URL.createObjectURL(fichier)}
                          alt={fichier.name}
                          style={{ width: "100%", height: "80%" }}
                        />
                        <button
                          className="btn btn-outline-danger col-sm mt-3 mb-3"
                          type="button"
                          onClick={() => handleDeletePieceJointe(index)}
                        >
                          <i className="fa fa-trash"></i>
                        </button>
                      </div>
                    ))}
                  </div>
                  {/* end of affichage des images  */}
                </div>
              </div>

              <div className="card-footer text-right">
                <button
                  type="button"
                  className="btn btn-secondary mr-2"
                  onClick={() => navigate("/Campagne/PageCampagneR")}
                >
                  Annuler
                </button>
                <button type="button" className="btn btn-dark" onClick={ajouterPublication}>
                  Ajouter
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
}

export default AddCampagneReseauxSociaux;
